var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSportTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    fillRule: "nonzero",
    d: "M31.57 1.78c-.4-.313-1.26-.65-4.092.065-.153.04-.303.078-.45.12.273-1.2.38-1.965.38-1.965H4.21s.102.72.358 1.857l-.046-.012C1.688 1.13.83 1.467.432 1.78c-.318.252-.47.627-.424 1.058.063.62.733 6.152 4.646 9.276 1.725 1.377 3.81 2.07 6.22 2.07h.032c.884.752 1.878 1.365 2.992 1.774v3.963h-3.32l-1.514 1.594V26h13.728v-4.486l-1.514-1.593H17.62v-3.925c1.16-.41 2.188-1.04 3.1-1.818.136.004.272.007.406.007 2.41 0 4.495-.693 6.22-2.07 3.913-3.124 4.583-8.656 4.646-9.276.045-.43-.106-.806-.423-1.057zM5.325 11.255c-3.564-2.845-4.18-7.956-4.24-8.53-.005-.05.002-.07 0-.07.006-.005.39-.423 2.99.21.268.063.532.133.786.204.74 2.823 2.204 7.004 4.857 9.954-1.676-.184-3.148-.773-4.394-1.768zm12.295.64c-.584.27-1.233.422-1.918.422-.64 0-1.25-.132-1.804-.37-1.66-.71-2.825-2.37-2.825-4.308 0-2.584 2.072-4.678 4.63-4.678 2.556 0 4.628 2.094 4.628 4.678 0 1.89-1.11 3.52-2.71 4.256zm13.294-9.17c-.06.574-.676 5.685-4.24 8.53-1.348 1.076-2.96 1.678-4.807 1.806 2.638-2.91 4.106-7.04 4.858-9.873.374-.11.782-.223 1.198-.324 2.606-.633 2.986-.212 2.99-.21 0 0 .006.02 0 .072z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSportTrophy);
export default __webpack_public_path__ + "static/media/sport-trophy.97978b041ce4b65136202244009129d0.svg";
export { ForwardRef as ReactComponent };